import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'white' | 'blue';
}
export function Section({
  children,
  className = '',
  id,
  background = 'default'
}: SectionProps) {
  const bgColors = {
    default: 'bg-[#FDFBF7]',
    white: 'bg-white',
    blue: 'bg-blue-50'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${bgColors[background]} ${className}`} data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">{children}</div>
    </section>;
}